module.exports = __webpack_public_path__ + "img/exit_to_app-white-18dp.518ae260.svg";